import React from 'react';
import {
  View,
  StyleSheet,
  ScrollView,
  KeyboardAvoidingView,
  Platform,
  Image,
  useWindowDimensions,
} from 'react-native';
import { colors } from '@/styles/colors';

interface AuthLayoutProps {
  children: React.ReactNode;
}

export const AuthLayout: React.FC<AuthLayoutProps> = ({ children }) => {
  const { width } = useWindowDimensions();
  const isDesktop = width >= 768;

  const renderIllustration = () => (
    <View style={styles.illustration}>
      <Image
        source={require('@/assets/images/vida-login-img.png')}
        style={styles.illustrationImage}
        resizeMode="contain"
      />
    </View>
  );

  if (isDesktop) {
    // Desktop: No scrolling, fixed layout
    return (
      <View style={styles.container}>
        <View style={[styles.card, styles.cardDesktop]}>
          {renderIllustration()}
          <View style={[styles.contentWrapper, styles.contentWrapperDesktop]}>
            <View style={[styles.contentContainer, styles.contentContainerDesktop]}>
              {children}
            </View>
          </View>
        </View>
      </View>
    );
  }

  // Mobile: Scrollable with keyboard handling
  return (
    <KeyboardAvoidingView
      style={styles.container}
      behavior={Platform.OS === 'ios' ? 'padding' : 'height'}
    >
      <ScrollView
        contentContainerStyle={styles.scrollContent}
        keyboardShouldPersistTaps="handled"
        showsVerticalScrollIndicator={false}
      >
        <View style={styles.card}>
          <View style={styles.contentWrapper}>
            <View style={styles.contentContainer}>
              {children}
            </View>
          </View>
        </View>
      </ScrollView>
    </KeyboardAvoidingView>
  );
};

const styles = StyleSheet.create({
  container: {
    flex: 1,
    backgroundColor: colors.background,
  },
  scrollContent: {
    minHeight: '100%',
    justifyContent: 'center',
    alignItems: 'center',
    padding: 16,
  },
  card: {
    width: '100%',
    maxWidth: 440,
    backgroundColor: colors.background,
  },
  cardDesktop: {
    maxWidth: '100%',
    flexDirection: 'row',
    height: '100%',
  },
  illustration: {
    flex: 1,
    backgroundColor: colors.illustration,
    justifyContent: 'center',
    alignItems: 'center',
    padding: 40,
  },
  illustrationImage: {
    width: '90%',
    aspectRatio: 1905 / 2880,
    maxWidth: 600,
  },
  contentWrapper: {
    width: '100%',
    padding: 40,
  },
  contentWrapperDesktop: {
    width: '50%',
    padding: 0,
    justifyContent: 'center',
    alignItems: 'center',
  },
  contentContainer: {
    width: '100%',
  },
  contentContainerDesktop: {
    width: '80%',
  },
});
